import { createDatasetSlice, ResponseMapping } from 'src/redux/helpers';
import { pepApiRequest, RequestMethod } from 'src/services';
import { API_ALERTS, ALERTS_STORE, ALERTS_STORE_LIST } from '../constants';

const api = () =>
  pepApiRequest({
    method: RequestMethod.Get,
    url: API_ALERTS,
  });

const alertsList = createDatasetSlice({
  api,
  storeName: ALERTS_STORE,
  actionName: ALERTS_STORE_LIST,
  responseMapping: ResponseMapping.Default,
});

export default alertsList;
